import { Typography } from 'antd';
const { Text } = Typography;

const ErrorText = ({ error }: { error: string }) => {
  return (
    <div style={{ margin: '8px 0px' }}>
      <Text type="danger" style={{ fontSize: '15px' }}>
        {error}
      </Text>
    </div>
  );
};

export default ErrorText;
